import { Login, LoginResponse } from '../../../types/login';
import { ApiAbstract } from '../abstract';

export class ApiLogin extends ApiAbstract<LoginResponse, Login> {}
